import { inject, Injectable } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import {
  NavigationCancel,
  NavigationCancellationCode,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router'

import { BehaviorSubject } from 'rxjs'

import { isMcpAuthLocation } from './mcp-interaction-capture'

@Injectable({ providedIn: 'root' })
export class McpAuthContext {
  private readonly router = inject(Router)
  private activeUrl = window.location.pathname + window.location.search
  private readonly profileEnabled = new BehaviorSubject(!this.isAuthUrl(this.activeUrl))
  public readonly profileEnabled$ = this.profileEnabled.asObservable()

  public get isAuthFlow(): boolean {
    return !this.profileEnabled.value
  }

  public constructor() {
    this.router.events.pipe(takeUntilDestroyed()).subscribe((event) => {
      if (event instanceof NavigationStart && this.isAuthUrl(event.url)) {
        // Suspend before guards and component construction; late ordinary /me results are fenced.
        this.profileEnabled.next(false)
      } else if (event instanceof NavigationEnd) {
        this.activeUrl = event.urlAfterRedirects
        this.profileEnabled.next(!this.isAuthUrl(this.activeUrl))
      } else if (
        event instanceof NavigationError ||
        (event instanceof NavigationCancel && event.code !== NavigationCancellationCode.Redirect)
      ) {
        this.profileEnabled.next(!this.isAuthUrl(this.activeUrl))
      }
    })
  }

  private isAuthUrl(url: string): boolean {
    return isMcpAuthLocation(new URL(url, window.location.origin))
  }
}
